const $ = require('jquery');
const headerAnalytics = require('./header.analytics');
const headerUtility = require('header.utility');
const thdCustomer = require('@thd-olt-global/thd-customer');

const config = {
  headerMyAccountSelector: '[data-js="my-account"]',
  headerMyAccountDropdownSelector: '[data-js="my-account-dropdown"]',
  headerMyAccountLinkSelector: '[data-js="my-account-link"]',
  myAccountGreetingSelector: '[data-js="my-account-greeting"]',
  myAccountGreetingMobileSelector: '[data-js="my-account-greeting-mobile"]',
  myAccountUsernameSelector: '[data-js="my-account-username"]',
  myAccountSwitchAccountSelector: '#myaccount-switch-accounts',
  addManageUsersSelector: '#myaccount-add-manage-users',
  signOutURL: `https://${headerUtility.getHostname()}/b2b/user/account/session/logout`,
  perksLink: '#myaccount-perks-page',
};

class HeaderMyAccount {
  constructor() {
    this._signOut = this._signOut.bind(this);
  }

  _logMyAccountLinkInteraction() {
    const text = $(this).text().toLowerCase().trim();
    return headerAnalytics.logEvent(
      'header click',
      ['header', 'my account', text].join('>'),
    );
  }

  _createTHDCustomerInfoRequest() {
    const url =
      this._getCustomerInfoRequestHostname() +
      '/b2b/user/account/state?get=browse';

    const requestOptions = {
      dataType: 'json',
      headers: {
        channelId: 1,
      },
      xhrFields: {
        withCredentials: true,
      },
      url,
      timeout: 10000,
    };

    return $.ajax(requestOptions);
  }

  _getCustomerInfoRequestHostname() {
    if (
      document.domain.indexOf('hd-qa71.homedepotdev') !== -1 ||
      document.domain.indexOf('hd-qa74.homedepotdev') !== -1
    ) {
      return '';
    } else {
      return 'https://www.homedepot.com';
    }
  }

  _fetchTHDCustomerInfo() {
    const customerInfoDeferred = $.Deferred(); // eslint-disable-line
    const customerInfoFallback = {
      firstName: '',
      numberOfServiceAccounts: '',
      role: '',
    };
    const userID = thdCustomer.default.userID;
    if (userID) {
      this._createTHDCustomerInfoRequest()
        .done((customerInfo) => customerInfoDeferred.resolve(customerInfo))
        .fail(() => customerInfoDeferred.resolve(customerInfoFallback));
    } else {
      customerInfoDeferred.resolve(customerInfoFallback);
    }

    return customerInfoDeferred.promise();
  }

  _updateMyAccountGreeting(username) {
    if (username && username !== 'self') {
      const firstName = username.toLowerCase();
      const greetingType = 'Hello,';
      const mobileGreeting = `${greetingType} ${firstName}`;

      $(config.myAccountGreetingSelector).html(greetingType);
      $(config.myAccountGreetingSelector).css('margin-top', '0');

      $(config.myAccountUsernameSelector).html(firstName);
      $(config.myAccountUsernameSelector).removeClass('u--hide');

      $(config.myAccountGreetingMobileSelector).html(mobileGreeting);
    }
  }

  // MyAccount SignOut
  _signOut(event) {
    const _redirectToNonSecurePage = () => {
      const nonSecureHostName = headerUtility.getHostname();
      window.location.assign(`https://${nonSecureHostName}`);
    };
    const _reloadPage = (xhr) => {
      if (xhr && xhr.status === 401) {
        window.location.reload();
      }
    };
    event.preventDefault();
    this._getSignOutRequest(config.signOutURL)
      .then(_redirectToNonSecurePage)
      .fail(_reloadPage);
    this.triggerRemovePerksLink();
  }

  _getSignOutRequest(url) {
    // IE8 support (might not be needed anymore)
    $.support.cors = true;
    const channelId = headerUtility.getChannelId();
    return $.ajax({
      url: url,
      type: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        channelId: channelId,
      },
      xhrFields: {
        withCredentials: true,
      },
      crossDomain: true,
    });
  }

  // Public Methods
  updateUserStatus() {
    this._fetchTHDCustomerInfo().then((customerInfo) => {
      if (customerInfo) {
        const username = customerInfo.firstName;
        const numberOfAccounts =
          Number(customerInfo.numberOfServiceAccounts) || 0;
        const role = customerInfo.role;
        this._updateMyAccountGreeting(username);
        this.triggerSwitchAccounts(numberOfAccounts);
        this.triggerAddManageUsers(role);
      }
      this.triggerUserUpdated();
    });
  }

  triggerUserUpdated() {
    // refresh Cart
    $(document).trigger({
      type: 'cartUpdated',
    });

    // refresh store
    $(document).trigger({
      type: 'newStoreSet',
    });
  }

  triggerSwitchAccounts(numberOfAccounts) {
    if (numberOfAccounts > 1) {
      $(config.myAccountSwitchAccountSelector).removeClass('u--hide');
    }
  }

  triggerAddManageUsers(role) {
    if (role && role.toLowerCase() === 'admin') {
      $(config.addManageUsersSelector).removeClass('u--hide');
    }
  }
  triggerRemovePerksLink() {
    const enrolledInPerksProgram = 'isEnrolledInPerksProgram';
    if (sessionStorage && sessionStorage.getItem(enrolledInPerksProgram)) {
      //this is a getter function in thd-customer app
      thdCustomer.default.clearPerksSession;
    }
  }
  init() {
    this.updateUserStatus();

    $(config.headerMyAccountLinkSelector).on(
      'click touchend',
      this._logMyAccountLinkInteraction,
    );
    $(document).on('click', '[data-myaccount-action="signout"]', this._signOut);
    $(document).on('updateUserStatus', this.triggerUserUpdated);
    $(document).on(
      'click',
      '#myaccount-switch-accounts',
      this.triggerRemovePerksLink,
    );

    $(config.headerMyAccountSelector).tooltip({
      type: 'click',
      noPad: true,
      closeOnClick: true,
      width: 'small',
      onClose: function () {
        $('.ma-profile__caret').removeClass('ma-profile__caret--open');
        $('.overlay-myaccount').removeClass('overlay-myaccount--open');
      },
      onOpen: function _onOpenTooltip($tooltip, complete) {
        let $overlay = $('.overlay-myaccount');
        if (!$overlay.length) {
          $overlay = $(
            '<div class="overlay-myaccount overlay-myaccount--open"></div>',
          ).appendTo('body');
        }
        $overlay.addClass('overlay-myaccount--open');
        $(config.headerMyAccountDropdownSelector)
          .removeClass('u--hide')
          .appendTo($tooltip);

        complete();

        $(document).trigger('openingHeaderToolTip', 'myaccount');
      },
    });
  }
}

module.exports = new HeaderMyAccount();
